import React, { useEffect, useState } from "react";
import {
  fetchFormData,
  formatTimeOnly,
  formatDateOnly,
} from "../../utils/options";
import Footer from "../shared/Footer";
import Input from "../shared/Input";
import SelectDropdown from "../shared/SelectDropdown";
import TextArea from "../shared/TextArea";
import Task2Header from "./Task2Header";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import PageHeader from "../shared/pageHeader/PageHeader";
import { useParams } from "react-router-dom";
import Table from "../shared/table/Table";

const TaskHistory = () => {
  const { id: taskId } = useParams();

  const [taskHistory, setTaskHistory] = useState([]);
  const [taskDetails, setTaskDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [userList, setUserList] = useState([]);
  const [taskCategory, setTaskCategory] = useState([]);
  const [taskPriorityOptions, setTaskPriorityOptions] = useState([]);

  useEffect(() => {
    if (taskId) {
      fetchTaskHistory();
      fetchTaskDetails(taskId);
    }
  }, [taskId]);

  const fetchTaskDetails = async (id) => {
    try {
      const formData = new FormData();
      formData.append("id", id);

      const result = await fetchFormData("task/getbyid", formData, "POST");
      if (result && result.data) {
        setTaskDetails(result.data);
      } else {
        setTaskDetails({});
      }
    } catch (error) {
      console.error("Failed to fetch task details:", error);
      setTaskDetails({});
    }
  };

  const fetchTaskHistory = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("task_id", taskId);

      const response = await fetchFormData("task-history", formData, "POST");

      if (response?.data) {
        setTaskHistory(response.data);
      } else {
        setTaskHistory([]);
      }
    } catch (error) {
      console.error("Failed to fetch task history:", error);
      setTaskHistory([]);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      accessorKey: "ActionDetails",
      header: "Action Details",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "changed_at",
      header: "Action Date",
      cell: (info) => formatDateOnly(info.getValue()),
      defaultIsVisible: true,
    },
    {
      accessorKey: "changed_at",
      header: "Action Time",
      cell: (info) => formatTimeOnly(info.getValue()),
      defaultIsVisible: true,
    },
    {
      accessorKey: "changed_by_name",
      header: "Action Change By",
      defaultIsVisible: true,
      cell: ({ getValue }) => {
        const name = getValue();
        return name ? name.charAt(0).toUpperCase() + name.slice(1) : "";
      },
    },
  ];

  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader />
          <Task2Header />
          <div className="main-content">
            <div className="row">
              <div className="task-details mb-6">
                <h5 className="section-title">Task Details</h5>
                <form className="details-font">
                  {/* Row 1 */}
                  <div className="row mb-3">
                    <div className="col-2 fw-semibold">Task Id:</div>
                    <div className="col-2">{taskDetails.task_Id || "-"}</div>

                    <div className="col-2 fw-semibold">Task Title:</div>
                    <div className="col-2">{taskDetails.task_title || "-"}</div>

                    <div className="col-2 fw-semibold">Task Category:</div>
                    <div className="col-2">
                      {taskDetails.assigned_category || "-"}
                    </div>
                  </div>

                  {/* Row 2 */}
                  <div className="row mb-3">
                    <div className="col-2 fw-semibold">Task Priority:</div>
                    <div className="col-2">{taskDetails.priority || "-"}</div>

                    <div className="col-2 fw-semibold">Task Notes:</div>
                    <div className="col-2">{taskDetails.notes || "-"}</div>

                    <div className="col-2 fw-semibold">Assign To User:</div>
                    <div className="col-2">
                      {taskDetails.assigned_user || "-"}
                    </div>
                  </div>

                  {/* Row 3 (Full width for details) */}
                  <div className="row mb-3">
                    <div className="col-2 fw-semibold">Task Details:</div>
                    <div className="col-2">
                      {taskDetails.task_details || "-"}
                    </div>

                    <div className="col-2 fw-semibold">Task Start Date:</div>
                    <div className="col-2">
                      {taskDetails.task_start_date
                        ? formatDateOnly(taskDetails.created_at)
                        : "-"}
                    </div>

                    <div className="col-2 fw-semibold">Task End Date:</div>
                    <div className="col-2">
                      {taskDetails.task_end_date
                        ? formatDateOnly(taskDetails.created_at)
                        : "-"}
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-2 fw-semibold">
                      Task Completed Date:
                    </div>
                    <div className="col-2">
                      {taskDetails.task_start_date
                        ? formatDateOnly(taskDetails.task_completed_on)
                        : "-"}
                    </div>
                  </div>
                </form>
              </div>

              <Table data={taskHistory} columns={columns} loading={loading} />
            </div>
          </div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default TaskHistory;
